// extracted by mini-css-extract-plugin
export default {"modalDialog":"v8rRtn7B","sticker":"CC8Q5sJb","stickerHuge":"bQ7CA6_X","error":"iEiAdwiC","step":"TI5caump"};